import styled from "styled-components";
import { formatCurrency } from "../../utils";
import QuantitySpinner from "../QuantitySpinner/QuantitySpinner";

const StyledCartProductContainer = styled.section`
  width: 100%;
  margin: 0 auto;
  padding: 0px;
  display: flex;
  gap: 15px;
`;

const StyledProductImage = styled.section`
  width: 40px;
  height: 40px;
  img {
    width: 100%;
    height: 100%;
  }
`;

const StyledProductDetails = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  h3 {
    font-size: 14px;
    font-weight: normal;
    margin: 0px;
    padding: 0px;
    color: #000000;
  }
  p {
    font-size: 12px;
    margin: 0px;
    padding: 0px;
    color: #9b9b9b;
  }
`;

const StyledRemoveButton = styled.button`
  font-size: 12px;
  font-weight: normal;
  color: red;
  background-color: transparent;
  margin: 0px;
  padding: 0px;
  outline: 0px;
  cursor: pointer;
  border: 0px;
  width: fit-content;
  height: fit-content;
  transition: color 0.5s ease;
  &:hover {
    color: #b00000;
    transition: color 0.5s ease;
  }
`;

const StyledSpinnerContainer = styled.section`
  display: flex;
  align-items: center;
`;

const StyledPriceDetails = styled.section`
  display: flex;
  align-items: center;
  p {
    font-size: 14px;
    font-weight: 500;
    margin: 0px;
    padding: 0px;
    color: green;
  }
`;

const CartProductCard = ({
  id,
  productTitle,
  photo,
  mrp,
  srp,
  quantity,
  incrementQuantity,
  decrementQuantity,
  removeProduct,
}) => {
  return (
    <StyledCartProductContainer>
      <StyledProductImage>
        <img src={photo ? photo : "/no-image.jpg"} alt={productTitle} />
      </StyledProductImage>
      <StyledProductDetails>
        <h3>{productTitle}</h3>
        <p>{formatCurrency(srp ? srp : mrp)}</p>
        <StyledRemoveButton onClick={() => removeProduct(id)}>
          Remove
        </StyledRemoveButton>
      </StyledProductDetails>
      <StyledSpinnerContainer>
        <QuantitySpinner
          value={quantity}
          onIncrement={() => incrementQuantity(id)}
          onDecrement={() => decrementQuantity(id)}
        />
      </StyledSpinnerContainer>
      <StyledPriceDetails>
        <p>{formatCurrency(quantity * (srp ? srp : mrp))}</p>
      </StyledPriceDetails>
    </StyledCartProductContainer>
  );
};

export default CartProductCard;
